var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { DbStore } from './store';
import { downloader } from '../downloader';
var dbStore = new DbStore();
/**
 * 下载并缓存单个文件
 */
function getSingleResource(url, callback) {
    return __awaiter(this, void 0, void 0, function () {
        var resource;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dbStore.get(url)];
                case 1:
                    resource = _a.sent();
                    if (!!resource) return [3 /*break*/, 4];
                    resource = new Blob([]);
                    return [4 /*yield*/, downloader(url, callback)];
                case 2:
                    resource = _a.sent();
                    return [4 /*yield*/, dbStore.set(url, resource)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4:
                    if (callback) {
                        callback(1);
                    }
                    return [2 /*return*/, resource];
            }
        });
    });
}
/**
 * 获取并缓存资源
 */
function getResource(params) {
    return __awaiter(this, void 0, void 0, function () {
        var resource, _a, isCreateObjectURL, callback, result, type, keys, dividePercent_1, nowPercent_1, allProgressCallback, i, key, singleRes, dividePercent_2, nowPercent_2, allProgressCallback, i, singleRes, singleRes;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    resource = params.resource, _a = params.isCreateObjectURL, isCreateObjectURL = _a === void 0 ? true : _a, callback = params.callback;
                    result = '';
                    type = Object.prototype.toString.call(resource);
                    if (!(type === '[object Object]')) return [3 /*break*/, 5];
                    // 对象参数
                    result = {};
                    keys = Object.keys(resource);
                    dividePercent_1 = 1 / keys.length;
                    nowPercent_1 = 0;
                    allProgressCallback = function (percent) {
                        if (callback) {
                            callback(nowPercent_1 + dividePercent_1 * percent);
                        }
                    };
                    i = 0;
                    _b.label = 1;
                case 1:
                    if (!(i < keys.length)) return [3 /*break*/, 4];
                    key = keys[i];
                    nowPercent_1 = dividePercent_1 * i;
                    return [4 /*yield*/, getSingleResource(resource[key], allProgressCallback)];
                case 2:
                    singleRes = _b.sent();
                    result[key] = isCreateObjectURL ? URL.createObjectURL(singleRes) : singleRes;
                    _b.label = 3;
                case 3:
                    i++;
                    return [3 /*break*/, 1];
                case 4: return [3 /*break*/, 12];
                case 5:
                    if (!Array.isArray(resource)) return [3 /*break*/, 10];
                    // 数组参数
                    result = [];
                    dividePercent_2 = 1 / resource.length;
                    nowPercent_2 = 0;
                    allProgressCallback = function (percent) {
                        if (callback) {
                            callback(nowPercent_2 + dividePercent_2 * percent);
                        }
                    };
                    i = 0;
                    _b.label = 6;
                case 6:
                    if (!(i < resource.length)) return [3 /*break*/, 9];
                    nowPercent_2 = dividePercent_2 * i;
                    return [4 /*yield*/, getSingleResource(resource[i], allProgressCallback)];
                case 7:
                    singleRes = _b.sent();
                    result[i] = isCreateObjectURL ? URL.createObjectURL(singleRes) : singleRes;
                    _b.label = 8;
                case 8:
                    i++;
                    return [3 /*break*/, 6];
                case 9: return [3 /*break*/, 12];
                case 10:
                    if (!(type === '[object String]')) return [3 /*break*/, 12];
                    return [4 /*yield*/, getSingleResource(resource, function (percent) {
                            if (callback) {
                                callback(percent);
                            }
                        })];
                case 11:
                    singleRes = _b.sent();
                    result = isCreateObjectURL ? URL.createObjectURL(singleRes) : singleRes;
                    _b.label = 12;
                case 12: return [2 /*return*/, result];
            }
        });
    });
}
export { getResource };
